'use client';

import { MapContainer, MapBox } from './styles';
import { FC } from 'react';
import type {
  InitialMapState,
  MapSearchResultEvent,
  MapSearchStatusEvent,
  MapSelection,
  MapStateChangeEvent,
  MapWidgetState,
  SearchFilters,
} from '@propileya/geo-widget';
import { Loader } from '@/components';

import dynamic from 'next/dynamic';

const GeoWidget = dynamic(
  () => import('@/components/shared/GeoWidget/index').then((m) => m.GeoWidget),
  { ssr: false, loading: () => <Loader /> },
);

type MapContentProps = {
  filters: SearchFilters;
  selection: MapSelection;
  initialState: InitialMapState;
  onReady?: (state: MapWidgetState) => void;
  onStateChange?: (event: MapStateChangeEvent) => void;
  onSearchResult?: (event: MapSearchResultEvent) => void;
  onSearchStatusChange?: (event: MapSearchStatusEvent) => void;
};

export const MapContent: FC<MapContentProps> = ({
  filters,
  selection,
  initialState,
  onReady,
  onStateChange,
  onSearchResult,
  onSearchStatusChange,
}) => {
  return (
    <MapContainer>
      <MapBox>
        <GeoWidget
          filters={filters}
          selection={selection}
          initialState={initialState}
          onReady={onReady}
          onStateChange={onStateChange}
          onSearchResult={onSearchResult}
          onSearchStatusChange={onSearchStatusChange}
        />
      </MapBox>
    </MapContainer>
  );
};
